// extracted by mini-css-extract-plugin
export default {"FAQBtn":"FAQComponent_FAQBtn__vcWWn","answer":"FAQComponent_answer__UqL2Q","joinUl":"FAQComponent_joinUl__z-UL9"};